// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import { isOfficeFile, openOfficeFileInNewTab } from './FileViewer';
import MsgDialog from './MsgDialog';
import SelFolderDialog from './SelFolderDialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import DatePicker from '@mui/lab/DatePicker';
import SaveIcon from '@mui/icons-material/Save';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AddIcon from '@mui/icons-material/Add';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import Autocomplete from '@mui/material/Autocomplete';

import dayjs from 'dayjs';
import { AgGridReact } from 'ag-grid-react';

import { useDropzone } from 'react-dropzone';

import ConfirmDialog from './ConfirmDialog';

export default function DocCheckHistEditDialog(props) {

  const { sysID, docDetail, open, onClose, viewMode, viewCheckLog, isCheckIn, afterUpdate } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const checkOutHistData = docDetail?.CheckOutHists || [];
  // console.log('🚀 ~ DocCheckHistEditDialog ~ docDetail:', docDetail);

  const histCnt = checkOutHistData.length;

  const lastCheckOutHist = (histCnt > 0) ? checkOutHistData[histCnt - 1] : null;
  // console.log('🚀 ~ DocCheckHistEditDialog ~ lastCheckOutHist:', lastCheckOutHist);

  const isAddMode = !viewMode && ((lastCheckOutHist === null) || (lastCheckOutHist && lastCheckOutHist.Completed));
  // console.log('🚀 ~ DocCheckHistEditDialog ~ isAddMode:', isAddMode);
  // console.log('🚀 ~ DocCheckHistEditDialog ~ viewMode:', viewMode);

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const submitBtnRef = useRef();

  const handleFormSubmit = () => {
    submitBtnRef?.current?.click();
  }


  const { control, handleSubmit, getValues, setValue, watch } = useForm({
    defaultValues: {
      id: 0,
      requestBy: "",
      requestDate: null,
      requestReason: "",
      handleBy: "",
      handleDate: null,
      solicitor: "",
      sentOutBy: "",
      sentOutDate: null,
      sentOutReason: "",
      checkInBy: "",
      returnBy: "",
      returnDate: null,
      returnRemark: "",
      fileLoc: "",
      createdBy: "",
      createdByName: "",
      createdDate: null,
      updatedBy: "",
      updatedByName: "",
      updatedDate: null,
    }
  });

  const watchCreatedDate = watch("createdDate");
  const watchUpdatedDate = watch("updatedDate");
  const watchRequestReason = watch("requestReason");
  const watchSolicitor = watch("solicitor");
  const watchFileLocation = watch("fileLoc");
  const watchSentOutReason = watch("sentOutReason");


  const handleRequestReasonChange = (event, newValue) => {
    setValue("requestReason", newValue || "");
  };

  const handleSolicitorChange = (event, newValue) => {
    setValue("solicitor", newValue || "");
  };

  const handleFileLocationChange = (event, newValue) => {
    setValue("fileLoc", newValue || "");
  };

  const handleSentOutReasonChange = (event, newValue) => {
    setValue("sentOutReason", newValue || "");
  };


  const [openFolderDialog, setOpenFolderDialog] = useState(false);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");


  const [selFiles, setSelFiles] = useState([]);
  const [selDelAttNoList, setSelDelAttNoList] = useState([]);

  const [requestReasonOptions, setRequestReasonOptions] = useState([]);
  const [solicitorOptions, setSolicitorOptions] = useState([]);
  const [fileLocationOptions, setFileLocationOptions] = useState([]);
  const [sentOutReasonOptions, setSentOutReasonOptions] = useState([]);


  useEffect(() => {
    const xFunc = async () => {
      if (open) {
        setSelFiles([]);
        setSelectedRecs([]);
        setSelDelAttNoList([]);

        const vData = await DmsService.getOptionsForCheckInHistPromise(gState.sessionID, sysID);
        // console.log('🚀 ~ DocCheckHistEditDialog ~ vData:', vData);

        if (vData && vData.requestReasonList) {
          setRequestReasonOptions(vData.requestReasonList);
        }
        if (vData && vData.solicitorList) {
          setSolicitorOptions(vData.solicitorList);
        }
        if (vData && vData.fileLocationList) {
          setFileLocationOptions(vData.fileLocationList);
        }
        if (vData && vData.sentOutReasonList) {
          setSentOutReasonOptions(vData.sentOutReasonList);
        }

        if (isAddMode) {
          // Add mode
          setValue("requestBy", gState.fullName || "");
          setValue("requestDate", dayjs().startOf('date'));
          setValue("requestReason", "");
          setValue("handleBy", "");
          setValue("handleDate", null);
          setValue("solicitor", "");
          setValue("sentOutBy", "");
          setValue("sentOutDate", null);
          setValue("sentOutReason", "");
          setValue("checkInBy", "");
          setValue("returnBy", "");
          setValue("returnDate", null);
          setValue("returnRemark", "");
          setValue("fileLoc", "");
          setValue("createdBy", gState.userID);
          setValue("createdByName", gState.fullName);
          setValue("createdDate", dayjs().startOf('date'));
          setValue("updatedBy", gState.userID);
          setValue("updatedByName", gState.fullName);
          setValue("updatedDate", dayjs().startOf('date'));
        } else {
          // View/Edit/CheckIn mode
          // console.log('🚀 ~ DocCheckHistEditDialog ~ viewCheckLog:', viewCheckLog);
          // console.log('🚀 ~ DocCheckHistEditDialog ~ vCheckOutHist:', vCheckOutHist);
          const vCheckOutHist = viewMode ? viewCheckLog : lastCheckOutHist;

          setValue("id", vCheckOutHist.id);
          setValue("requestBy", vCheckOutHist.RequestBy || "");
          setValue("requestDate", vCheckOutHist.RequestDate ? dayjs(vCheckOutHist.RequestDate).startOf('date') : null);
          setValue("requestReason", vCheckOutHist.RequestReason || "");
          setValue("handleBy", vCheckOutHist.HandleBy || "");
          setValue("handleDate", vCheckOutHist.HandleDate ? dayjs(vCheckOutHist.HandleDate).startOf('date') : null);
          setValue("solicitor", vCheckOutHist.Solicitor || "");
          setValue("sentOutBy", vCheckOutHist.SentOutBy || "");
          setValue("sentOutDate", vCheckOutHist.SentOutDate ? dayjs(vCheckOutHist.SentOutDate).startOf('date') : null);
          setValue("sentOutReason", vCheckOutHist.SentOutReason || "");
          setValue("checkInBy", vCheckOutHist.CheckInBy || "");
          setValue("returnBy", vCheckOutHist.ReturnBy || "");
          setValue("returnDate", vCheckOutHist.ReturnDate ? dayjs(vCheckOutHist.ReturnDate).startOf('date') : null);
          setValue("returnRemark", vCheckOutHist.ReturnRemark || "");
          setValue("fileLoc", vCheckOutHist.FileLocation || "");
          setValue("createdBy", vCheckOutHist.CreatedBy || "");
          setValue("createdByName", vCheckOutHist.CreatedByName || "");
          setValue("createdDate", vCheckOutHist.CreatedDate ? dayjs(vCheckOutHist.CreatedDate) : null);
          setValue("updatedBy", vCheckOutHist.UpdatedBy || "");
          setValue("updatedByName", vCheckOutHist.UpdatedByName || "");
          setValue("updatedDate", vCheckOutHist.UpdatedDate ? dayjs(vCheckOutHist.UpdatedDate) : null);

          const vAttFiles = []


          for (let i = 0; i < vCheckOutHist.AttList.length; i++) {
            const file = vCheckOutHist.AttList[i];

            vAttFiles.push({
              "attNo": file.AttNo,
              "name": file.Filename,
              "size": file.FileSize,
              "createdBy": file.CreatedBy,
              "createdDate": dayjs(file.CreatedDate),
              "createdDateDisplay": file.CreatedDate ? dayjs(file.CreatedDate).format(DmsCommon.SHORT_DATE_FORMAT) : "",

              FileSizeDisplay: DmsCommon.getReadableFileSizeString(file.FileSize),
              "isNew": false,
            });
          }

          setSelFiles(vAttFiles);
        }

        // if (isCheckIn) {
        //   // Check-In mode - load lastCheckOutHist data
        //   setValue("requestBy", lastCheckOutHist.RequestBy || "");
        //   setValue("requestDate", lastCheckOutHist.RequestDate ? dayjs(lastCheckOutHist.RequestDate) : null);
        // } else {

        // }


      }
    }
    xFunc();


  }, [open])


  const uploadFile = async (aFile) => {
    if (!aFile || aFile.size === 0) return "";
    if (aFile.size > DmsCommon.MAX_FILE_SIZE) {
      throw new Error("File size exceeds 2GB limit!");
    }
    const vFileID = await DmsService.uploadChunkedFilePromise(
      gState.sessionID,
      aFile
    );
    return vFileID;
  }

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const resolverRef = useRef();

  const confirmDeleteDialog = () =>
    new Promise((resolve) => {
      resolverRef.current = resolve;
      setOpenConfirmDialog(true);
    });

  const handleConfirmDeleteOk = () => {
    resolverRef.current?.(true);
    setOpenConfirmDialog(false);
  }

  const handleConfirmDeleteCancel = () => {
    resolverRef.current?.(false);
    setOpenConfirmDialog(false);
  }


  const onSubmit = data => {
    // console.log("Submit data", data);


    const xFunc = async () => {
      setShowLoading(true);

      try {

        if (isAddMode) {
          // validate required fields for Add
          if (lastCheckOutHist && lastCheckOutHist.Completed) {
            if (data.requestDate < dayjs(lastCheckOutHist.RequestDate).startOf('date')) {
              throw new Error(`Check Out Date should not earlier than last Check In Date!`);
            }
          }
        } else if (isCheckIn) {
          // validate required fields for Check-In
          if (data.returnDate < data.sentOutDate) {
            throw new Error(`Check In Date should not earlier than Sent Out Date!`);
          }
        }

        const vDocID = docDetail?.DocID || 0;

        const vRequestDateISO = data.requestDate?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";
        const vHandleDateISO = data.handleDate?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";
        const vSentOutDateISO = data.sentOutDate?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";

        const vNewFiles = []

        for (let i = 0; i < selFiles.length; i++) {
          const file = selFiles[i];
          if (file.isNew && file.size > DmsCommon.MAX_FILE_SIZE) {
            throw new Error(`File size exceeds 2GB limit: ${file.name}`);
          }
        }

        for (let i = 0; i < selFiles.length; i++) {
          const file = selFiles[i];
          if (file.isNew) {
            // console.log('🚀 ~ xFunc ~ file:', file);
            const vFileID = await uploadFile(file.fileObj);
            vNewFiles.push({
              "FileID": vFileID,
              "FileName": file.name,
              "FileSize": file.size,
            });

          }
        }

        if (selDelAttNoList.length > 0) {

          const confirmedDelete = await confirmDeleteDialog();
          // console.log('🚀 ~ handleDelClick ~ confirmDelete result:', confirmedDelete);

          if (!confirmedDelete) {
            setShowLoading(false);
            return;
          }
        }

        if (isCheckIn) {
          // Check-In
          await DmsService.checkInHistPromise(gState.sessionID, sysID, data.id,
            data.checkInBy, data.returnBy, data.returnDate, data.returnRemark, data.fileLoc,
            vNewFiles, selDelAttNoList
          );
        } else {
          if (isAddMode) {

            // Add new Check-Out History
            await DmsService.addCheckOutHistPromise(gState.sessionID, sysID,
              vDocID, data.requestBy, vRequestDateISO,
              data.requestReason, data.handleBy, vHandleDateISO,
              data.sentOutBy, vSentOutDateISO, data.sentOutReason,
              data.solicitor, vNewFiles
            );
          } else {
            // Edit existing Check-Out History
            await DmsService.updateCheckOutHistPromise(gState.sessionID, sysID,
              vDocID, data.id, data.requestBy, vRequestDateISO,
              data.requestReason, data.handleBy, vHandleDateISO,
              data.sentOutBy, vSentOutDateISO, data.sentOutReason,
              data.solicitor, vNewFiles, selDelAttNoList
            );

          }

        }



        setShowLoading(false);

        afterUpdate && afterUpdate();
      } catch (e) {
        setShowLoading(false);
        onCatchPromiseError(e);
      }

    }
    xFunc();
  }



  const Input = styled('input')({
    display: 'none',
  });

  const handleSelectedUploadFile = (e) => {
    const vFiles = e.target.files;
    // console.log("handleSelectedUploadFile", vFiles);

    if (vFiles.length === 1) {

      const vSelFile = vFiles[0];

      let newFiles = [...selFiles];

      const vUploadToday = dayjs();

      if (!newFiles.some(f => f.name === vSelFile.name)) {

        newFiles.push({
          "isNew": true,
          "name": vSelFile.name,
          "size": vSelFile.size,
          // "createdBy": gState.fullName || "",
          // "createdDate": vUploadToday ,
          // "createdDateDisplay": vUploadToday ? vUploadToday.format(DmsCommon.SHORT_DATE_FORMAT) : "",
          "createdBy": "",
          "createdDate": null,
          "createdDateDisplay": "",
          FileSizeDisplay: DmsCommon.getReadableFileSizeString(vSelFile.size),
          "fileObj": vSelFile,
        });
      }

      setSelFiles(newFiles);
      setSelectedRecs([]);
    }

  }

  const [selectedRecs, setSelectedRecs] = useState([]);
  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });

    setSelectedRecs(selRecs);

  }

  const handleOpenClick = () => {

    if (selectedRecs.length == 1) {

      const selAttFile = selectedRecs[0];
      // console.log(selAttFile);

      if (selAttFile.isNew) {
        const url = URL.createObjectURL(selAttFile.fileObj);
        if (isOfficeFile(selAttFile.name)) {
          openOfficeFileInNewTab({
            url: url,
            filename: selAttFile.name,
            title: selAttFile.name,
            canDownload: true,
          });
        } else {
          window.open(url);
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 1000);
        }
      } else {
        const vFileExt = DmsCommon.getFileExtension(selAttFile.name);

        if (isOfficeFile(selAttFile.name)) {
          const vDownloadURL = DmsService.getDownloadUrlWithFilename(gState.sessionID, sysID, docDetail.DocID, null, null, null, selAttFile.attNo, 0, selAttFile.name);
          openOfficeFileInNewTab({
            url: vDownloadURL,
            filename: selAttFile.name,
            title: `${docDetail?.Subject || selAttFile.name} (Attachment: ${selAttFile.name})`,
            canDownload: docDetail?.Permission >= DmsCommon.AccessRightEnum.arReadDn,
          });
        } else {
          const vIsAttach = (vFileExt == '.pdf' || vFileExt == '.txt') ? 0 : 1;
          const vDownloadURL = DmsService.getDownloadUrl(gState.sessionID, sysID, docDetail.DocID, null, null, null, selAttFile.attNo, vIsAttach);
          window.open(vDownloadURL, '_blank');
        }

        // Noted: According to DMSWin32, It is intended to log as download instead of open
        DmsService.accessLogPromise(gState.sessionID, sysID, DmsCommon.DmsLogEnum.daCheckLogAttOpen, `${docDetail.DocID}`);
      }

    }
  }
  const handleDownloadClick = () => {

    const xFunc = async () => {

      if (selectedRecs.length == 1) {
        const selAttFile = selectedRecs[0];
        // console.log('🚀 ~ handleDownloadClick ~ selRec:', selAttFile);

        try {
          if (selAttFile.isNew) {
            const blob = new Blob([selAttFile.fileObj]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = selAttFile.name;
            a.click();
          } else {
            DmsService.downloadFileStream(
              gState.sessionID,
              sysID,
              docDetail.DocID,
              null,
              null,
              null,
              selAttFile.attNo,
              selAttFile.name,
              () => setShowLoading(true),
              () => setShowLoading(false),
              (err) => {
                onCatchPromiseError(err);
              }
            );
            DmsService.accessLogPromise(gState.sessionID, sysID, DmsCommon.DmsLogEnum.daCheckLogAttDownload, `${docDetail.DocID}`);
          }
        } catch (e) {
          setShowLoading(false);
          onCatchPromiseError(e);
        }

      }

    }
    xFunc();

  }
  const handleDelClick = () => {
    // console.log('🚀 ~ handleDelClick ~ selectedRecs:', selectedRecs);

    const xFunc = async () => {

      if (selectedRecs.length == 1) {

        const vDelRec = selectedRecs[0];
        // console.log('🚀 ~ xFunc ~ vDelRec:', vDelRec);

        const vAttNo = vDelRec.attNo || 0;

        // just remove from selFiles
        const newFiles = selFiles.filter(f => f.name !== vDelRec.name);
        setSelFiles(newFiles);


        // also remove from selDelAttNoList if file already have attNo (i.e. file already uploaded before)
        if (vAttNo > 0) {
          let newDelAttNo = [...selDelAttNoList];
          if (!newDelAttNo.includes(vAttNo)) {
            newDelAttNo.push(vAttNo);
            setSelDelAttNoList(newDelAttNo);
          }

        }

        setSelectedRecs([]);
      }


    }
    xFunc();

  }
  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const columnDefs = [
    { field: 'name', headerName: "File", cellStyle: cellStyle, width: 400 },
    {
      field: 'FileSizeDisplay', headerName: "Size", cellStyle: cellStyle, width: 120
    },
    {
      field: 'createdBy', headerName: "Uploaded By", cellStyle: cellStyle, width: 200
    },
    {
      field: 'createdDateDisplay', headerName: "Upload Date", cellStyle: cellStyle, width: 120
    },
  ];

  let vTitle = "Handle"
  if (isCheckIn) {
    vTitle = "Check-In";
  } else if (viewMode) {
    vTitle = "View Handle";
  } else {
    if (isAddMode) {
      vTitle = "New Handle";
    } else {
      vTitle = "Edit Handle";
    }
  }

  const viewOrCheckIn = viewMode || isCheckIn;


  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <ConfirmDialog
        open={openConfirmDialog}
        text="Are you sure to delete the uploaded file?"
        confirmBtnCaption='Delete'
        onCancelClick={handleConfirmDeleteCancel}
        onConfirmClick={handleConfirmDeleteOk}
      />

      <DialogTitle >
        {vTitle}
      </DialogTitle>
      <DialogContent>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={{ xs: 1 }}  >
            <Grid item xs={12} sx={{ mb: 1 }} >
              <Chip label="Request" size="small" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Controller
                name="requestBy"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Request By"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    {...field}
                    required

                    disabled={viewOrCheckIn}
                    InputLabelProps={{ shrink: true, }}
                  />}
              />

            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="requestDate"
                control={control}
                render={({ field }) =>
                  <DatePicker
                    label="Request Date"
                    type="date"
                    disabled={viewOrCheckIn}
                    inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                    {...field}
                    renderInput={(params) => <TextField
                      variant={viewOrCheckIn ? "outlined" : "standard"}
                      size="small"
                      fullWidth
                      {...params}
                      required


                      InputLabelProps={{ shrink: true, }}
                    />}
                  />}
              />
            </Grid>
            <Grid item xs={12} >
              <Autocomplete
                freeSolo
                options={requestReasonOptions}
                value={watchRequestReason}
                onChange={handleRequestReasonChange}
                disabled={viewOrCheckIn}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Reason"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    disabled={viewOrCheckIn}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sx={{ my: 1 }} >
              <Chip label="Handle" size="small" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Controller
                name="handleBy"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Handled By"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    {...field}

                    disabled={viewOrCheckIn}

                    InputLabelProps={{ shrink: true, }}
                  />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="handleDate"
                control={control}
                render={({ field }) =>
                  <DatePicker
                    label="Handled Date"
                    type="date"
                    inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                    {...field}
                    disabled={viewOrCheckIn}
                    renderInput={(params) => <TextField
                      variant={viewOrCheckIn ? "outlined" : "standard"}
                      size="small"
                      fullWidth
                      {...params}
                      InputLabelProps={{ shrink: true, }}
                    />}
                  />}
              />
            </Grid>
            <Grid item xs={12} >
              {/* <Controller
                name="solicitor"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Recipient"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    {...field}

                    disabled={viewOrCheckIn}
                    InputLabelProps={{ shrink: true, }}
                  />}
              /> */}
              <Autocomplete
                freeSolo
                options={solicitorOptions}
                value={watchSolicitor}
                onChange={handleSolicitorChange}
                disabled={viewOrCheckIn}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Recipient"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    disabled={viewOrCheckIn}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sx={{ my: 1 }} >
              <Chip label="Sent Out" size="small" />
            </Grid>

            <Grid item xs={12} sm={6}>

              <Controller
                name="sentOutBy"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Sender"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    {...field}

                    disabled={viewOrCheckIn}
                    InputLabelProps={{ shrink: true, }}
                  />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                name="sentOutDate"
                control={control}
                render={({ field }) =>
                  <DatePicker
                    label="Sent Out Date"
                    type="date"
                    disabled={viewOrCheckIn}
                    inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                    {...field}
                    renderInput={(params) => <TextField
                      variant={viewOrCheckIn ? "outlined" : "standard"}
                      size="small"
                      fullWidth
                      {...params}
                      InputLabelProps={{ shrink: true, }}

                    />}
                  />}
              />
            </Grid>
            <Grid item xs={12} >
              {/* <Controller
                name="sentOutReason"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Reason"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    {...field}

                    disabled={viewOrCheckIn}
                    InputLabelProps={{ shrink: true, }}
                  />}
              /> */}
              <Autocomplete
                freeSolo
                options={sentOutReasonOptions}
                value={watchSentOutReason}
                onChange={handleSentOutReasonChange}
                disabled={viewOrCheckIn}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Reason"
                    variant={viewOrCheckIn ? "outlined" : "standard"}
                    size="small"
                    fullWidth
                    disabled={viewOrCheckIn}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>

            {(isCheckIn || viewMode) && <>

              <Grid item xs={12} sx={{ my: 1 }} >
                <Chip label="Return" size="small" />
              </Grid>

              <Grid item xs={12} >

                <Controller
                  name="checkInBy"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      label="Check By"
                      variant={isCheckIn ? "standard" : "outlined"}
                      size="small"
                      fullWidth
                      {...field}

                      required={isCheckIn}
                      disabled={!isCheckIn}
                      InputLabelProps={{ shrink: true, }}
                    />}
                />
              </Grid>
              <Grid item xs={12} sm={6}>

                <Controller
                  name="returnBy"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      label="Return By"
                      variant={isCheckIn ? "standard" : "outlined"}
                      size="small"
                      fullWidth
                      {...field}

                      required={isCheckIn}
                      disabled={!isCheckIn}

                      InputLabelProps={{ shrink: true, }}
                    />}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="returnDate"
                  control={control}
                  render={({ field }) =>
                    <DatePicker
                      label="Return Date"
                      type="date"
                      disabled={!isCheckIn}
                      inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                      {...field}
                      renderInput={(params) => <TextField
                        variant={isCheckIn ? "standard" : "outlined"}
                        size="small"
                        fullWidth
                        {...params}

                        required={isCheckIn}
                        InputLabelProps={{ shrink: true, }}
                      />}
                    />}
                />
              </Grid>
              <Grid item xs={12} >
                <Controller
                  name="returnRemark"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      label="Remark"
                      variant={isCheckIn ? "standard" : "outlined"}
                      size="small"
                      fullWidth
                      {...field}

                      disabled={!isCheckIn}
                      InputLabelProps={{ shrink: true, }}
                    />}
                />
              </Grid>
              <Grid item xs={12} >
                {/* <Controller
                  name="fileLoc"
                  control={control}
                  render={({ field }) =>
                    <TextField
                      label="File Location"
                      variant={isCheckIn ? "standard" : "outlined"}
                      size="small"
                      fullWidth
                      {...field}

                      disabled={!isCheckIn}
                      InputLabelProps={{ shrink: true, }}
                    />}
                /> */}
                <Autocomplete
                  freeSolo
                  options={fileLocationOptions}
                  value={watchFileLocation}
                  onChange={handleFileLocationChange}
                  disabled={!isCheckIn}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="File Location"
                      variant={isCheckIn ? "standard" : "outlined"}
                      size="small"
                      fullWidth
                      disabled={!isCheckIn}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />

              </Grid>
            </>}



            <Grid item xs={12} sx={{ my: 1 }} >
              <Chip label="Attachment" size="small" />
            </Grid>

            <Grid item xs={12} >
              <Box sx={{ py: 1, px: 1 }} >

                {!viewMode && <>
                  <label htmlFor="icon-button-add-file">
                    <Input id="icon-button-add-file" type="file" onChange={handleSelectedUploadFile} />
                    <Button component="span" startIcon={<AddIcon />}  >
                      Add
                    </Button>
                  </label>

                  <Button disabled={selectedRecs.length != 1} startIcon={<DeleteIcon />} onClick={handleDelClick} >
                    Delete
                  </Button>

                </>}


                <Button disabled={selectedRecs.length != 1} startIcon={<OpenInNewIcon />} onClick={handleOpenClick}  >
                  Open
                </Button>

                <Button disabled={selectedRecs.length != 1} startIcon={<CloudDownloadIcon />} onClick={handleDownloadClick}   >
                  Download
                </Button>


              </Box>
              <div className="ag-theme-material" style={{ width: '100%', height: '300px', bgcolor: 'yellow' }}>
                <AgGridReact

                  rowData={selFiles}

                  defaultColDef={{
                    width: 100,
                    resizable: true,
                    sortable: true,
                    suppressMovable: true,
                  }}
                  columnDefs={columnDefs}
                  headerHeight={40}

                  suppressNoRowsOverlay

                  rowSelection="single"
                  onSelectionChanged={onSelectionChanged}
                >

                </AgGridReact>

              </div>
            </Grid>


            <Grid item xs={12} sm={6}>
              <Controller
                name="createdByName"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Created By"
                    variant="filled"
                    size="small"
                    fullWidth
                    {...field}

                    InputProps={{ readOnly: true, }}
                    InputLabelProps={{ shrink: true, }}
                  />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Created Date"
                variant="filled"
                size="small"
                fullWidth
                value={watchCreatedDate ? watchCreatedDate.format(DmsCommon.SHORT_DATE_FORMAT) : ""}
                InputProps={{ readOnly: true, }}
                InputLabelProps={{ shrink: true, }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>

              <Controller
                name="updatedByName"
                control={control}
                render={({ field }) =>
                  <TextField
                    label="Updated By"
                    variant="filled"
                    size="small"
                    fullWidth
                    {...field}

                    InputProps={{ readOnly: true, }}
                    InputLabelProps={{ shrink: true, }}
                  />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Upload Date"
                variant="filled"
                size="small"
                fullWidth
                value={watchUpdatedDate ? watchUpdatedDate.format(DmsCommon.SHORT_DATE_FORMAT) : ""}
                InputProps={{ readOnly: true, }}
                InputLabelProps={{ shrink: true, }}
              />
            </Grid>
            <Button type="submit" variant="contained" startIcon={<SaveIcon />} sx={{ display: "none" }} ref={submitBtnRef} >Save</Button>
          </Grid>



        </form>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>{viewMode ? "Close" : "Cancel"}</Button>
        {!viewMode && <>
          <Button variant="contained" startIcon={<SaveIcon />} onClick={handleFormSubmit} >Save</Button>
        </>}


      </DialogActions>
    </Dialog >

  );
}

DocCheckHistEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  viewMode: PropTypes.bool,
  viewCheckLog: PropTypes.object,
  isCheckIn: PropTypes.bool,
  afterUpdate: PropTypes.func,
};
